var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('a-button',{staticClass:"code",attrs:{"type":"primary"},on:{"click":_vm.jumpTo}},[_vm._v("跳转扫码登录页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }